import { action, makeObservable, observable, computed } from 'mobx' 

class TransitionStore {
    constructor(rootStore) {
        this.rootStore = rootStore;

        makeObservable(this)
    };

    isInitialLoad = true;
    @observable routeTransitioning = false;
    @observable transitionStartExit = false;
    @observable routePath = undefined

    @action startTransition(location, prevLocation) {
        // if (this.isInitialLoad) {
        //     return
        // }

        if (this.routeTransitioning) return
        this.rootStore.uiStore.openNavModule()
        this.routeTransitioning = true;
        this.routePath = window.location.pathname;
    }

    @action.bound endTransition() {
        // if (this.isInitialLoad) {
        //     this.clearTransition()
        //     return
        // }

        this.transitionStartExit = true;

        setTimeout(this.clearTransition, 700)
    }

    @action.bound clearTransition() {
        this.isInitialLoad = false;
        this.routeTransitioning = false;
        this.transitionStartExit = false;
        this.routeTransition = false;
    }


    @computed get routeName() {
        if (this.routePath) {
            if (this.routePath === "/") {
                return "home"
            }
            if (this.routePath === "/about/") {
                return "about"
            }
            if (this.routePath === "/articles/") {
                return "articles"
            }
                
        }
    }

    
}

export default TransitionStore